const RANK = { none: 0, view: 1, edit: 2, admin: 3 };

export const can = (user, module, level) => {
  if (module === "system_admin") return user?.role_name === "Admin";
  return (RANK[user?.permissions?.[module] || "none"] || 0) >= RANK[level];
};
